export default __webpack_public_path__ + "static/media/luke3.15072aed.jpg";